import React from 'react';
import { FiLock } from 'react-icons/fi';
import { useAuthStore } from '../../utils/store';
import { useT } from '../../utils/i18n';
import { FEATURES, hasFeature } from '../../utils/features';

/** Renders children only for users who have `feature` switched on (admins always do). */
export const FeatureGate = ({ feature, children }) => {
  const t = useT();
  const { user } = useAuthStore();
  if (hasFeature(user, feature)) return children;

  const label = t(FEATURES.find((f) => f.key === feature)?.labelKey || '');
  return (
    <div className="flex flex-col items-center justify-center text-center h-64 max-w-md mx-auto gap-3">
      <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
        <FiLock size={20} className="text-gray-400" />
      </div>
      <h1 className="text-lg font-semibold text-gray-900">{t('features.noAccessTitle', { feature: label })}</h1>
      <p className="text-sm text-gray-500">{t('features.noAccessDesc')}</p>
    </div>
  );
};
